export default "__VITE_ASSET__DQML03e3__"